import './Auth.css';
import logo from '../../image/Logo.svg';
import spinWheel from '../../image/wheel-big.png';
import React, { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import { postAuthSession } from '../../api/auth';
import { setSession } from '../../store/reducers/sessionReducer';

function Auth() {
  const dispatch = useDispatch();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [helperText, setHelperText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setHelperText('');
    if (!login.trim() || !password) {
      setHelperText('Введите логин и пароль');
      return;
    }
    setSubmitting(true);
    try {
      const result = await postAuthSession(login, password);
      if (result.status === 'ok') {
        try {
          localStorage.removeItem('id');
        } catch {
          /* ignore */
        }
        dispatch(setSession(result.data));
        window.location.href = '/';
        return;
      }
      if (result.status === 'forbidden' || result.status === 'client_error') {
        setHelperText(result.message || 'Нет доступа');
      } else if (result.status === 'unauthorized') {
        setHelperText('Неверный логин или пароль');
      } else {
        setHelperText(result.message || 'Ошибка авторизации');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-form">
        <img src={logo} className="Auth-logo" alt="logo" />
        <h1>Колесо баланса</h1>
        <div className="auth-form__input-field">
          <p>Вход в платформу</p>
          <form onSubmit={handleSubmit}>
            <TextField
              onChange={(e) => setLogin(e.target.value)}
              id="auth-login"
              label="Логин"
              variant="filled"
              fullWidth
              value={login}
              autoComplete="username"
              slotProps={{
                input: { disableUnderline: true },
              }}
            />
            <TextField
              onChange={(e) => setPassword(e.target.value)}
              id="auth-password"
              label="Пароль"
              type="password"
              variant="filled"
              fullWidth
              value={password}
              helperText={helperText}
              autoComplete="current-password"
              sx={{ mt: 1 }}
              slotProps={{
                input: { disableUnderline: true },
              }}
            />
            <button type="submit" className="auth-form__btn" disabled={submitting}>
              {submitting ? 'Вход…' : 'Войти'}
            </button>
          </form>
        </div>
      </div>
      <div className="auth-spin-wheel">
        <SpinWheel />
      </div>
    </div>
  );
}

export default Auth;

const SpinWheel = () => {
  const props = useSpring({
    from: { rotate: 0 },
    to: { rotate: 360 },
    config: { duration: 9525 },
    loop: true,
  });

  return (
    <animated.img style={props} src={spinWheel} alt="spin-wheel" className="spin-wheel" />
  );
};
